import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import LocationFilterToolbar from "../../App/LocationFilterToolbar";
import AppBar from "./../../components/DefaultAppBar";
import { withStyles } from "@mui/styles";
import { compose, mapProps } from "recompose";
import ProfileHeader from "./ProfileHeader";
import { withCurrentUser, withCurrentEstate } from "../../functions/hocs";
import FolderList from "../../components/Common/FolderList";
import IOSwitch from "../../components/Common/IOSCheckbox";
import { updateAccount, getCurrentAccount } from "../../modules/accounts";
import { ListItem, FormControl, Typography } from "@mui/material";
import { injectIntl } from "react-intl";
import { withCurrentAccount } from "../../modules/accounts/accountHocs";
import DocumentLayout from "../../components/Layouts/DocumentLayout";

export const route = "/profile/privacy";

const notificationSettingsContent = [
  {
    name: {
      id: "settings.public.tickets.new",
      defaultMessage: "Eine neue öffentliche Mitteilung",
    },
    type: "onNewPublicTicket",
  },
  {
    name: {
      id: "settings.public.tickets.answer",
      defaultMessage: "Eine Antwort auf eine öffentliche Mitteilung",
    },
    type: "onPublicTicketAnswer",
  },
  {
    name: {
      id: "settings.public.tickets.statusChange",
      defaultMessage: "Ein neuer Status einer Mitteilung",
    },
    type: "onPublicTicketStatusChange",
  },
  {
    name: {
      id: "settings.documents.new",
      defaultMessage: "Ein neues Dokument",
    },
    type: "onNewDocument",
  },
];

const SettingsList = React.memo(function SettingsList(props) {
  const {
    intl: { formatMessage },
    classes,
    handleSubmit,
    data,
    values,
    onChange,
    setFieldValue,
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <FolderList data={data}>
        {(document, index) => (
          <ListItem
            key={`${index}-${document.id}`}
            className={classes.container}
          >
            <Typography variant="subtitle1" inline>
              {formatMessage(document.name)}
            </Typography>
            <FormControl style={{ marginBottom: "12px" }}>
              <IOSwitch
                name={document.type}
                value={!!values[document.type]}
                checked={!!values[document.type]}
                onChange={(event, value) => {
                  onChange(document.type, value);
                  setFieldValue(document.type, value);
                }}
              />
            </FormControl>
          </ListItem>
        )}
      </FolderList>
    </form>
  );
});

const stylesList = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(),
    paddingBottom: 0,
  },
});

const IntelSettings = compose(
  injectIntl,
  withStyles(stylesList),
  mapProps((props) => ({
    ...props,
    values: { ...props.defaultSettings },
  })),
)(SettingsList);

/**
 *
 */
const ProfileContainer = (props) => {
  const [notificationSettings, setNotificationSettings] = useState({});

  useEffect(() => {
    const accountId = props.currentAccount.accountId;
    getCurrentAccount(accountId).then(({ data }) => {
      setNotificationSettings((data || {}).notificationSettings);
    });
  }, [props.currentAccount.accountId]);

  const handleChange = (field, value) => {
    const accountId = props.currentAccount.accountId;
    setNotificationSettings((prev) => {
      const newSettings = { ...prev, [field]: value };
      updateAccount(accountId, newSettings).then((data) =>
        setNotificationSettings(data),
      );
      return newSettings;
    });
  };

  const {
    classes,
    intl: { formatMessage },
  } = props;

  return (
    <div>
      <AppBar position="static">
        <LocationFilterToolbar noTicketFilter />
      </AppBar>

      <ProfileHeader estate={props.currentEstate} />

      <DocumentLayout>
        <Typography variant="h6" className={classes.content}>
          {formatMessage({ id: "profile.privacy.title.short" })}
        </Typography>

        <Typography className={classes.content}>
          {formatMessage({ id: "profile.privacy.title" })}
        </Typography>

        <Typography className={classes.content}>
          {formatMessage({ id: "profile.privacy.settings.desc" })}
        </Typography>

        {/* <div dangerouslySetInnerHTML={{ __html: title }} /> */}

        <IntelSettings
          data={notificationSettingsContent}
          onChange={handleChange}
          defaultSettings={notificationSettings}
        />
      </DocumentLayout>
    </div>
  );
};

ProfileContainer.route = route;

const styles = (theme) => ({
  center: {
    display: "flex",
    margin: "50% auto",
    fontSize: "10rem",
  },
  button: {
    width: "100%",
  },

  content: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    color: "rgba(0, 0, 0, 0.54)",
  },
});

export default compose(
  withRouter,
  injectIntl,
  withCurrentUser(),
  withCurrentAccount(),
  withCurrentEstate(),
  withStyles(styles),
)(ProfileContainer);
